import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import '../css/ColorFilters.css';

const ColorFilters = ({
  colors = [],
  selectedColors = [],
  setSelectedColors,
}) => {
  const toggleColor = (color) => {
    setSelectedColors((prev) =>
      prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
    );
  };

  return (
    <div className="d-flex flex-wrap justify-content-center gap-2">
      {colors.map(({ key, value }) => (
        <OverlayTrigger
          key={value}
          placement="top"
          overlay={<Tooltip>{key}</Tooltip>}
        >
          <div className="color-filter-wrapper">
            <input
              type="checkbox"
              className="btn-check"
              id={`color-${value}`}
              checked={selectedColors.includes(value)}
              onChange={() => toggleColor(value)}
            />
            <label
              htmlFor={`color-${value}`}
              className={`color-filter ${key === 'Bunt' ? 'bunt' : ''} ${
                selectedColors.includes(value) ? 'selected' : ''
              }`}
              style={key !== 'Bunt' ? { backgroundColor: value } : {}}
            >
              {selectedColors.includes(value) && (
                <span className={`checkmark ${key === 'Weiß' ? 'black' : ''}`}>
                  ✔
                </span>
              )}
            </label>
          </div>
        </OverlayTrigger>
      ))}
    </div>
  );
};

export default ColorFilters;
